export default "__VITE_ASSET__CNmHAN$S__"